import * as THREE from 'three'
import ballVertexShader from '../../shaders/ball/vertex.glsl'
import ballFragmentShader from '../../shaders/ball/fragment.glsl'
import Experience from '../experience.js'
import { POLE_HEIGHT, PLATFORM_HEIGHT } from './pole-platform.js'
import gsap from 'gsap';

const BALL_RADIUS = 3.81 / 2.0;
const DEFAULT_LIGHT_ONOFF_SPEED = 0.08; // 80 ms to turn on or off

export class Ball {

    ballSettings = {
        onOff: true,
        lightIntensity: 7,
    }


    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.textureLoader = this.experience.textureLoader;
        this.time = this.experience.time;
        this.sizes = this.experience.sizes;

        // Debug
        this.debugFolder = this.experience.gui.addFolder('Ball')
        this.debugFolder.close();

        this.setModel()
    }

    setModel()  {

        this.ballUniforms = {
            time: { type: "f", value: 1.0 },
            resolution: { type: "v2", value: new THREE.Vector2() },
            onOff:  { type: "f", value: this.ballSettings.onOff ? 1.0 : 0.0 }
        };

        const ballMaterial = new THREE.ShaderMaterial( {
            uniforms: this.ballUniforms,
            vertexShader: ballVertexShader,
            fragmentShader: ballFragmentShader,
            vertexColors: true
        });

        const ballGeometry = new THREE.IcosahedronGeometry( BALL_RADIUS, 3 );
     
        this.ballTopPosition = this.getBallPosY(60 * 1000); // Set to maximum height

        this.ball = new THREE.Mesh(ballGeometry, ballMaterial);
        this.ball.rotation.y = 0.85 * Math.PI; // Hide the ugly side with the seam
        this.ball.position.y = this.ballTopPosition;
        this.scene.add(this.ball);

        this.light = new THREE.PointLight(0xc5efdf, this.ballSettings.lightIntensity, 38, .4);
        this.light.position.x = 0;
        this.light.position.z = 0;
        this.light.position.y = this.ballTopPosition;
        this.scene.add(this.light);
        this.debugFolder.add(this.ballSettings, 'onOff').name('On / Off')
            .onChange((value) => {
                if (value) {
                    this.lightOn();
                } else {
                    this.lightOff();
                }
            }).listen();
        this.debugFolder.add(this.ballSettings, 'lightIntensity').min(0).max(100).step(0.001).name('Ball Light Intensity')
        .onChange((value) => {
            if (this.ballSettings.onOff) {
                this.light.intensity = value;
            }
        });
        this.debugFolder.add(this.light, 'distance').min(0).max(100).step(0.001).name('Ball Light Distance');
        this.debugFolder.add(this.light, 'decay').min(0).max(4).step(0.001).name('Ball Light Decay');
    }


    update(elapsedTime, timeLeft) {
        this.ballUniforms.time.value = elapsedTime;

        if (timeLeft < 60000 || this.ball.position.y !== this.ballTopPosition) {
            const ballPosY = this.getBallPosY(timeLeft);
            this.ball.position.y = ballPosY;
            this.light.position.y = ballPosY;
        }
    }

    getBallPosY(timeLeft) {
        const ballDropProgress = Math.max(0.0, Math.min(1.0, (60.0 - (timeLeft / 1000.0)) / 60.0));
        const maxHeight = POLE_HEIGHT - (BALL_RADIUS * 2.0);
        return maxHeight - (maxHeight * ballDropProgress) + BALL_RADIUS + PLATFORM_HEIGHT;
    }

    lightOn(dur) {
        if (typeof dur === 'undefined') {
            dur = DEFAULT_LIGHT_ONOFF_SPEED;
        }

        gsap.to(
            this.ballUniforms.onOff,
            { value: 1, duration: dur, ease: 'linear' },
        );
        gsap.to(
            this.light,
            { intensity: this.ballSettings.lightIntensity,
                duration: dur, ease: 'linear' },
        );
        this.ballSettings.onOff = true;
    }

    lightOff(dur) {
        if (typeof dur === 'undefined') {
            dur = DEFAULT_LIGHT_ONOFF_SPEED;
        }

        gsap.to(
            this.ballUniforms.onOff,
            { value: 0, duration: dur, ease: 'linear' },
        );
        gsap.to(
            this.light,
            { intensity: 0,
                duration: dur, ease: 'linear' },
        );
        this.ballSettings.onOff = false;
    }
}